export default __webpack_public_path__ + "static/media/photo--sm--blitz-6.9cda940e.jpg";